// 領収書発行ウィジェットの文言（Issue #46）。
//
// ★★ここは各店のフリーページ11枚の原文をそのまま写したもの。勝手に整えない。
//   2026-09-17 に11店ぶんを実機から読み比べ、**本文は一字一句同じ**であることを確認した
//   （誤字「宛名をは30文字以内に」、全角スペース「領収書データ　送信完了」、
//     「解決しない場合は  お問い合わせ」の半角スペース2つ、まで含めて共通）。
//   直すなら「原文を直す」という判断が先に要る。移植のついでに直さない。
//
// ★11店で割れていた3点と、ウィジェットでの寄せ方（PR に記載）:
//   1. ご登録メールアドレスのラベル … 「ご登録メール<br>アドレス」(2,6) /「ご登録メールアドレス」(1,3,4,11) /
//      「ご登録<br>メールアドレス」(9,10,14,15,16) の3通り。→ <br> を持たず1行にし、折り返しは CSS に任せる
//   2. TOPに戻る … 10店が全角「ＴＯＰに戻る」、コミック侍(11)だけ半角「TOPに戻る」。→ 多数派の全角に寄せる
//   3. 送信ボタン … A系6店は画像で文字が無く、B系5店は <button>「領収書メール送信」「領収書再送信」。
//      → B系の文言を採る（発行画面の説明文が「領収書メール送信ボタンを押すと」と言っているため）

export const TEXT = {
  /** mode 1: 発行画面 */
  issue: {
    title: '領収書発行ページ',
    lead: [
      '下記の項目をご入力頂き、領収書メール送信ボタンを押すと、',
      'Ｅメールが送信されます。電子領収書となりますので、お手数ですがご自身で印刷の上ご利用ください。',
    ],
    button: '領収書メール送信',
  },

  /** 明細の行ラベル */
  label: {
    siteName: 'ご購入サイト',
    orderNo: '受注番号',
    name: '宛名',
    description: '但し書き',
    price: '領収額',
    date: '領収日',
    mailAddress: 'ご登録メールアドレス',
  },

  /** 値に添える短い語 */
  unit: {
    /** 宛名の後ろ */
    honorific: '様',
    yen: '円',
    taxIncluded: '（税込）',
    dateHelp: '領収日はご購入日となります。',
  },

  /** 入力の検証。★「宛名をは」は原文の誤字。直さない */
  validation: {
    nameRequired: '宛名を入力してください',
    nameTooLong: '宛名をは30文字以内にしてください',
  },

  /** mode 2: 送信完了 */
  done: {
    title: '領収書データ　送信完了',
    body: [
      'ありがとうございました。',
      '領収書はメールで送信されます。',
      '電子領収書となりますので、ご自身で印刷の上ご利用ください。',
      '',
      '尚、万が一メールが届かない場合は、お手数ですが、受注番号をお知らせください。',
    ],
    topLink: 'ＴＯＰに戻る',
  },

  /** mode 3: 再送信画面 */
  reissue: {
    title: '領収書再送信ページ',
    lead: [
      'すでに領収書は発行済みになっています。',
      '下部のボタンを押すと、領収書が添付されたメールが再送信されます。',
      '電子領収書となりますので、お手数ですがご自身で印刷の上ご利用ください。',
    ],
    button: '領収書再送信',
  },

  /** mode 4: 処理中 */
  sending: {
    body: '送信処理中です...',
  },

  /** mode 5: エラー */
  error: {
    body: [
      '領収書発行でエラーが発生しました。時間をおいて再度お試しください。',
      '解決しない場合は  お問い合わせにて連絡をお願いします。',
    ],
  },

  /**
   * ★現行に無い状態（Issue #46 の5状態には含まれない・このウィジェットで足したもの）。
   *
   * 現行は guid が無いとき（mode -2）も、受注が見つからないとき（応答が null で
   * `c.data.isIssued` が例外になる）も、**画面が真っ白のまま**になる。
   * 客はなぜ何も出ないのか分からず、店は「ページが壊れている」という問い合わせを受ける。
   * 通信エラー（mode 5）とは原因が違うので「時間をおいて再度お試しください」も当たらない。
   * ⇒ 別の状態として、何をすればよいかを出す。★この文言だけは新規なので、確認のうえ変えてよい。
   */
  notFound: {
    body: [
      '領収書の情報を読み込めませんでした。',
      'お手数ですが、発送完了メールに記載のリンクからもう一度お開きください。',
      '解決しない場合は  お問い合わせにて連絡をお願いします。',
    ],
  },
} as const

/**
 * 種類。`order` = 通常の受注（メール送信）/ `est` = 別注（PDF ダウンロード）。
 * 画面の流れは同じで、違うのは API のパス・文言・発行後に出すもの（メールの案内か、ダウンロードのリンクか）だけ。
 */
export type ReceiptKind = 'order' | 'est'

/**
 * ★別注用（EstReceiptIssueApp）の文言。4 ページ（1=922 / 3=271 / 4=95 / 6=207）の原文（2026-09-26 保存）を写したもの。
 *   基準は opp-honpo 271。4 枚で割れていたのは次の 2 点で、多数派に寄せた:
 *     - 再ダウンロード画面の 2 行目 … 「下部のボタンから再表示できます」(1,3,6) /「再発行できます」(4) → 再表示
 *     - 宛名の検証 … 「宛名を入力してください」だけ (1,3,6) / 30 文字超の文言もある (4)。
 *       validate() は 4 店とも 30 文字で止めているので、止まる理由が見える 4 の形にする（文言は通常版と同じ）
 *   「ご登録メールアドレス」の行は 4 店ともコメントアウトで出していないので、出さない。
 *   ボタンは 4 店とも画像（文字なし）なので、通常版と同じ方針で説明文に合わせた文言を付ける。
 *   通常版と共通の文言（行ラベル・単位・検証・処理中・エラー・notFound）は TEXT のものをそのまま使う。
 */
export const EST_TEXT = {
  /** mode 1: 発行画面 */
  issue: {
    title: '領収書発行ページ',
    lead: [
      '下記の項目をご入力頂き、領収書発行ボタンを押すとPDFファイルがダウンロードできます。',
      '電子領収書となりますので、お手数ですがご自身で印刷の上ご利用ください。',
    ],
    button: '領収書発行',
  },

  /** mode 2: 発行直後。メールではなくダウンロードのリンクを出す */
  done: {
    title: '領収書 ダウンロード',
    body: [
      '下記ダウンロードボタンを押すとことで領収書PDFのダウンロードができます',
      '電子領収書となりますので、ご自身で印刷の上ご利用ください。',
    ],
    download: '領収書ダウンロード',
    topLink: 'ＴＯＰに戻る',
  },

  /** mode 3: 発行済み。ボタンは無く、ダウンロードのリンクだけ（現行どおり宛名の入力欄も出ない） */
  reissue: {
    title: '領収書再ダウンロードページ',
    lead: [
      'すでに領収書は発行済みになっています。',
      '下部のボタンから再表示できます',
      '電子領収書となりますので、お手数ですがご自身で印刷の上ご利用ください。',
    ],
    download: '領収書ダウンロード',
  },
} as const
